import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, Divider, TextField, Fab, Tooltip, InputAdornment } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import AddIcon from '@material-ui/icons/Add'

import { CustomButton } from 'components'
import { useFormState } from 'hooks/useFormState'
import { useCadaverService } from 'hooks/useCadaverService'
import { useStyles } from './FormAnalisesInternas.styles'

const schema = {
  incisao: {
    presence: { allowEmpty: false, message: '^Incisão é obrigatório' },
  },
  regiao: {
    presence: { allowEmpty: false, message: '^Região da análise é obrigatória' },
  },
}

export const FormAddAnaliseInterna = (props) => {
  const {
    setIsFormAddAnaliseInternaAtivo,
    idExame,
    idCadaver,
    setAnalisesInternas,
    setProcessando,
    processando,
  } = props
  const cadaverService = useCadaverService()
  const classes = useStyles()
  const [observacoes, setObservacoes] = useState(['observacao0'])
  const formAddAnaliseInterna = useFormState(schema, {
    incisao: '',
    regiao: '',
    outroTipoIncisao: '',
    observacoes: [],
  })

  const formError = () => {
    let disable = false
    if (!formAddAnaliseInterna.formState.values.incisao) {
      disable = true
    }
    if (!formAddAnaliseInterna.formState.values.regiao) {
      disable = true
    }
    return disable
  }

  const handleCancelar = () => {
    setIsFormAddAnaliseInternaAtivo(false)
  }

  const handleConfirm = async () => {
    const obs = []
    Object.keys(formAddAnaliseInterna.formState.values).forEach((key) => {
      if (key.indexOf('observacao') !== -1) {
        obs.push(formAddAnaliseInterna.formState.values[key])
      }
    })

    const dados = {
      ...formAddAnaliseInterna.formState.values,
      observacoes: obs,
    }

    await cadaverService.cadastrarAnaliseInternaCadaver(idExame, idCadaver, dados, setProcessando)
    cadaverService.getAnalisesInternasCadaver(
      idExame,
      idCadaver,
      setAnalisesInternas,
      setProcessando
    )
    setIsFormAddAnaliseInternaAtivo(false)
  }

  const handleAdicionarObservacao = () => {
    const newInput = `observacao${observacoes.length}`
    const array = observacoes.concat([newInput])
    setObservacoes(array)
  }

  return (
    <div>
      <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
        <Grid item md={8} sm={8} xs={12} className={classes.CampoForm}>
          <AutocompleteNative
            value={
              formAddAnaliseInterna.formState.values.regiao
                ? formAddAnaliseInterna.formState.values.regiao
                : null
            }
            name="regiao"
            noOptionsText="Sem informações"
            options={[
              'CABEÇA',
              'PESCOÇO',
              'TRONCO',
              'MEMBRO SUPERIOR ESQUERDO',
              'MEMBRO SUPERIOR DIREITO',
              'MEMBRO INFERIOR ESQUERDO',
              'MEMBRO INFERIOR DIREITO',
            ]}
            onChange={(event, newValue) => {
              formAddAnaliseInterna.handleChangeNewValueByNameProperty(event, newValue, 'regiao')
            }}
            required
            getOptionLabel={(option) => option}
            renderOption={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                label="Região analisada"
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            )}
          />
        </Grid>
        <Grid item md={8} sm={8} xs={12} className={classes.CampoForm}>
          <AutocompleteNative
            name="incisao"
            value={formAddAnaliseInterna.formState.values.incisao || null}
            noOptionsText="Sem informações"
            options={[
              'BIMASTOIDEA',
              'MENTOFÚRCULA',
              'MENTOPUBIANA',
              'MENTOXIFÓIDE',
              'XIFOPUBIANA',
              'FURCULOPUBIANA',
              'OUTRO',
            ]}
            onChange={(event, newValue) =>
              formAddAnaliseInterna.handleChangeNewValueByNameProperty(event, newValue, 'incisao')
            }
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                label="Tipo de incisão"
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            )}
          />
        </Grid>

        {(formAddAnaliseInterna.formState.values.incisao === 'OUTRO') ? 
          (<Grid item md={8} sm={8} xs={12} className={classes.CampoForm}>
            <TextField
              fullWidth
              name="outroTipoIncisao"
              onChange={formAddAnaliseInterna.handleChange}
              value={formAddAnaliseInterna.formState.values.outroTipoIncisao || ''}
              className= {classes.labelInput}
              label="Outro Tipo de Incisão"
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                maxLength: 1000,
              }}
            />
          </Grid>)
          : null
        }

        <Grid className={classes.CampoForm} item md={10} sm={12} xs={12}>
          {observacoes.map((input, index) => (
            <TextField
              key={input}
              fullWidth
              className={classes.inputForm}
              label={`Observação (${index + 1})`}
              name={input}
              onChange={formAddAnaliseInterna.handleChange}
              value={formAddAnaliseInterna.formState.values[input] || ''}
              InputProps={{
                endAdornment: index + 1 === observacoes.length && (
                  <InputAdornment position="start">
                    <Tooltip title="Adicionar observação">
                      <Fab
                        color="primary"
                        size="small"
                        onClick={() => handleAdicionarObservacao()}
                        className={classes.botaoAddObservacao}
                      >
                        <AddIcon />
                      </Fab>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.labelInput,
              }}
            />
          ))}
        </Grid>

        <Grid item md={12} sm={12} xs={12} className={classes.dividerBotton}>
          <Divider />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
            <CustomButton onClick={handleCancelar} variant="text">
              Cancelar
            </CustomButton>

            <CustomButton
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              disabled={formError() || processando}
              isLoading={processando}
            >
              Adicionar Análise Interna
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

FormAddAnaliseInterna.propTypes = {
  setIsFormAddAnaliseInternaAtivo: PropTypes.func.isRequired,
  idExame: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCadaver: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setAnalisesInternas: PropTypes.func.isRequired,
  setProcessando: PropTypes.func.isRequired,
  processando: PropTypes.bool.isRequired,
}
